import { gql } from 'urql'

const QueryUniversalSearch = gql`
  query ($search: String) {
    universalSearch(search: $search)
  }
`

export default QueryUniversalSearch
